
import { mapGetters } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import Button from '~/components/buttons/Button'
import generateHeader from '~/helpers/header'
import LoleFormError from '~/components/form/error/lole-error-form'

export default {
  name: 'ForgetPassword',
  components: {
    Button,
    LoleFormError,
  },
  async asyncData({ error, app: { $storyblok, $sentryException } }) {
    try {
      const { story } = await $storyblok.getStory(`/pages/forget_password_page`)
      return { wording: story.content }
    } catch (e) {
      $sentryException(e, {
        source: 'storyblok',
        level: 'warning',
        extra: 'Call storyblok forget_password_page failed',
      })
      error({
        statusCode: 500,
        message: 'Call storyblok forget_password_page failed',
      })
    }
  },
  data: () => ({
    wording: null,
    email: null,
    submitted: false,
    errors: [],
    success: false,
    loading: false,
  }),
  head() {
    if (!this.wording.SEO) return
    this.wording.SEO.og_image = this.wording.SEO.og_image
      ? this.wording.SEO.og_image
      : this.$config.DEFAULT_OG_IMAGE
    return generateHeader({
      ...this.wording.SEO,
      path: this.$route.path,
    })
  },
  computed: {
    ...mapGetters({
      vxWordingErrors: 'common/getErrorsForm',
    }),
  },
  methods: {
    async submit() {
      this.loading = true
      this.success = false
      this.$v.$touch()
      this.submitted = true
      this.errors = []
      if (!this.$v.$invalid) {
        try {
          await this.$store.dispatch('customer/recoverCustomer', this.email)
          this.success = true
        } catch (e) {
          this.success = false
          if (e.message.includes('Resetting password limit exceeded')) {
            this.errors.push({ code: 'LIMIT-EXCEEDED-RESET-PWD' })
          } else {
            this.errors.push({ code: null })
            this.$sentryException(e, {
              source: 'Page /forget-password',
              level: 'warning',
              extra: 'Store fetch dispatch failed - customer/customerRecover',
            })
          }
        }
      }
      this.loading = false
    },
  },
  validations: {
    email: {
      required,
      email,
    },
  },
}
